const {Component} = require("react");
const userStore = require("stores/UserStore");
const {classList} = require("helpers/html");
const {observer} = require("mobx-react");
const {computed} = require("mobx");
const router = require("services/router");

@observer
class ProfileUrl extends Component {

	@computed
	get approved() {
		return userStore.get("registration_status") === "approved";
	}

	@computed
	get className() {
		return classList(
			"profile-url",
			!this.approved && "unavailable"
		);
	}

	@computed
	get url() {
		return router.route("profile", {username: userStore.get("username")});
	}

	renderLink() {
		if (this.approved) {
			return (
				<a href={this.url} target="_blank">Vis profil</a>
			);
		}
	}

	render() {
		return (
			<div className={this.className}>{this.renderLink()}</div>
		);
	}

}

module.exports = ProfileUrl;


// WEBPACK FOOTER //
// ./resources/js/components/backend/ProfileUrl.js